export class SetScannerTypes {
  static readonly type = '[ScannerTypeState] SetScannerTypes';
  constructor(public readonly scannerTypes: string[]) {}
}
